import type * as React from 'react';

function SvgArrowDownCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M15.7197 9.71975L12 13.4394L8.2803 9.71975C7.9873 9.42675 7.5127 9.42675 7.2198 9.71975C6.9269 10.0127 6.9268 10.4874 7.2198 10.7803L11.4698 15.0303C11.6163 15.1768 11.8077 15.25 12.0001 15.25C12.1925 15.25 12.3839 15.1768 12.5304 15.0303L16.7804 10.7803C17.0734 10.4873 17.0734 10.0126 16.7804 9.71975C16.4874 9.42685 16.0126 9.42675 15.7197 9.71975Z"
        fill="currentColor"
      />
      <path
        d="M12 2C6.4863 2 2 6.4858 2 12C2 17.5142 6.4863 22 12 22C17.5137 22 22 17.5142 22 12C22 6.4858 17.5137 2 12 2ZM12 20C7.5889 20 4 16.4111 4 12C4 7.5889 7.5889 4 12 4C16.4111 4 20 7.5889 20 12C20 16.4111 16.4111 20 12 20Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgArrowDownCircle;
